/**
 * The shop's identity, as large as the canvas allows: its logo when it has
 * one, otherwise its name, set big and held to three lines. Never the POS
 * logo standing in for the shop. Until the logo has loaded the name holds
 * the space, so nothing jumps.
 */
export default function ShopLogo({ src, title }: { src: string | null; title?: string }) {
  if (src) {
    return <img src={src} alt={title ?? ''} className="block h-full w-full motion-safe:animate-stageIn object-contain" />
  }
  return (
    <div className="line-clamp-3 max-w-full break-words text-center font-volte-semibold text-cfd-hero text-primary">{title}</div>
  )
}
